import { Pipe, PipeTransform } from '@angular/core';
import { DirectoryColumn } from '../../samwebDescription/samweb/directory/directory-column';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { DirectoryStructureState } from '../../store/samwin/directory/directory-structure/directory-structure.state';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
   name: 'directoryColumnTitle',
})
export class DirectoryColumnTitlePipe implements PipeTransform {
   constructor(private store: Store, private translationService: TranslateService) {}

   transform(directoryColumnTyp: DirectoryColumn): Observable<string> {
      return this.store
         .select(DirectoryStructureState.columnTitleForDirectoryColumn)
         .pipe(map((filterFn) => filterFn(directoryColumnTyp, this.translationService)));
   }
}
